import React from "react";
import { useSelector } from "react-redux";

import { Center } from "@seneca/senekit";
import { useSimpleNavigationCallback } from "seneca-common/utils/hooks/routing";

import { regionMetas } from "common/static/regions/regionMetas";
import { linkToRegionModal } from "common/links";
import { getRegion, DEFAULT_REGION } from "features/regions/selectors";

import styles from "./FlagRegionLink.module.scss";

type Props = {
  onClick?: () => void;
};

export default function FlagRegionLink({ onClick }: Props) {
  const openRegionSelectionModal = useSimpleNavigationCallback(
    linkToRegionModal()
  );
  const region = useSelector(getRegion) || DEFAULT_REGION;

  const Flag = (regionMetas as any)[region].FlagComponent;

  return (
    <button
      className={styles.button}
      onClick={onClick ? onClick : openRegionSelectionModal}
      aria-label="Select region"
    >
      <Center>
        <Flag alt={region} width={["25px", "30px"]} />
      </Center>
    </button>
  );
}
